module.exports = __webpack_public_path__ + "img/symbol_4.ad341b56.png";